import type { BundleMessage } from './BundleMessage.js';
import type { BundleOutputFile } from './BundleOutputFile.js';

/**
 * Result returned by a bundler plugin (`Bundler#bundle()`).
 * Excludes properties that can be filled in automatically.
 */

export interface BundlerResult {
  /**
   * The absolute output path of the bundle.
   */
  outputPath?: string;

  /**
   * The output files produced by bundling.
   */
  outputFiles?: BundleOutputFile[];

  /**
   * Errors encountered during bundling.
   */
  errors?: BundleMessage[];

  /**
   * Warnings encountered during bundling.
   */
  warnings?: BundleMessage[];

  /**
   * The raw input options passed along into the bundler, for debugging purposes.
   * May be missing if something prevented executing the bundler.
   */
  rawInput?: Record<string, unknown>;

  /**
   * The raw output emitted from the bundler, for debugging purposes.
   * May be missing if something prevented the bundler from returning output.
   */
  rawOutput?: Record<string, unknown>;

  /**
   * If incremental bundling is specified, provide a way to rebuild the project.
   */
  rebuild?: () => Promise<BundlerResult>;

  /**
   * If incremental bundling is specified, provide a way to shut down the incremental build job.
   */
  dispose?: () => void;
}
